import { WishType } from 'enums/wish'

export const getUserWishesByWishType = (user, wishType: WishType) =>
  user?.wishlist?.wishes?.filter(wish => wish.wishable_type === wishType)
